import HrbrCkeditorUpgradeModal from '../components/Modals/HrbrCKeditorUpgradeModal.vue';
import SuperdocShareModal from '../components/SuperdocContainer/SuperdocShareModal.vue';
import { ModalProgrammatic as Modal } from 'buefy';


/**
 * This plugin is needed to open a modal from any component, even from old code.
 */
function openCkeditorUpgradeModal(options = {}) {
  const { props = {}} = options;
  const modal = Modal.open({
    parent: props.parent || this,
    component: HrbrCkeditorUpgradeModal,
    hasModalCard: true,
    fullScreen: false,
    canCancel: true,
    props,
  });
  return modal;
}

function openSuperdocShareModal(options = {}) {
  const { props = {}, events = {} } = options;
  const modal = Modal.open({
    component: SuperdocShareModal,
    parent: props.parent || this,
    fullScreen: false,
    canCancel: true,
    props,
    events,
  });

  return modal;
}

export default {
  install(Vue) {
    Vue.prototype.$openCkeditorUpgradeModal = openCkeditorUpgradeModal;
    Vue.prototype.$openSuperdocShareModal = openSuperdocShareModal;
  },
};
